export const COLORS = {
  highlight: "#49dede",
  bodyText: "#ccc",
  titles: "#fff",
  darkText: "#888",
  bgColor: "#092121",
};

export const SPACING = {
  sm_spacing: "8px",
  md_spacing: "16px",
  lg_spacing: "24px",
  xl_spacing: "32px",
};

export const BREAKPOINTS = {
  sm_breakpoint: "450px",
  md_breakpoint: "768px",
  lg_breakpoint: "1024px",
};
